import { type FC } from 'react'

import {
  FreeformTextareaEditor,
  type FreeformTextareaProps
} from '../FreeformTextareaEditor/FreeformTextareaEditor'

export const SQLAdvancedEditor: FC<FreeformTextareaProps> = ({ ...props }) => (
  <FreeformTextareaEditor {...props} language="sql" />
)
